const parallaxElements = document.querySelectorAll('.parallax');

parallaxElements.forEach(el => {
  
  window.addEventListener("scroll", (event) => {
    const parallaxImage = el.querySelector('.parallax-image');
    let multiplier = 60;
    if (window.innerWidth > 768) multiplier = 160;
    let offset = ((window.innerHeight / 2) + window.scrollY - el.offsetTop) / window.innerHeight * multiplier;
    if (offset > multiplier) offset = multiplier;
    if (offset < (multiplier * -1)) offset = (multiplier * -1);
    parallaxImage.style.transform = 'translateY(' + offset + 'px)';
    parallaxImage.style.top = '-' + multiplier + 'px';
    parallaxImage.style.bottom = '-' + multiplier + 'px';
  });
  
  window.scrollTo(window.scrollX, window.scrollY - 1);
  window.scrollTo(window.scrollX, window.scrollY + 1);

});